import React, { useState } from "react";
import { Tabs as MuiTabs, Tab, useMediaQuery } from "@mui/material";

export interface TabConfig {
    label: string;
    component: React.ReactNode;
    key?: string | number;
    hide?: boolean;
}

const defaultTabs: TabConfig[] = [
    {
        label: "Tab 1",
        component: <>Tab Body</>,
    },
];

export interface TabsProps {
    tabConfig: TabConfig[];
    defaultKeyValue?: TabConfig["key"];
    getSelectedTabKeyValue?: (value: TabConfig["key"]) => void;
}

export const Tabs = ({
    defaultKeyValue,
    tabConfig = defaultTabs,
    getSelectedTabKeyValue
}: TabsProps) => {
    const [value, setValue] = useState(() => {
        return defaultKeyValue ?? tabConfig[0]?.key ?? 0;
    });

    const isMobileOrTablet = useMediaQuery('(max-width: 1200px)');
    const handleChange = (
        _: React.SyntheticEvent,
        newValue: TabConfig["key"]
    ) => {
        if (newValue != undefined) setValue(newValue);
        if (getSelectedTabKeyValue) getSelectedTabKeyValue(newValue);
    };

    return (
        <div>
            <MuiTabs
                value={value}
                onChange={handleChange}
                allowScrollButtonsMobile	
                variant={isMobileOrTablet ? "scrollable" : "standard"}
                scrollButtons="auto"
            >
                {tabConfig.map((tab, index) => {
                    if (tab.hide) return undefined;
                    return (
                        <Tab
                            label={tab.label}
                            key={"tab-" + (tab.key ?? index)}
                            value={tab.key ?? index}
                        />
                    );
                })}
            </MuiTabs>
            {tabConfig.map((tab, index) => {
                if (tab.hide) return undefined;
                return (
                    <div
                        role="tabpanel"
                        hidden={(tab.key ?? index) !== value}
                        key={"tab-panel-" + (tab.key ?? index)}
                    >
                        {tab.component}
                    </div>
                );
            })}
        </div>
    );
};
